module.exports = __webpack_public_path__ + "img/vr_design.44853f08.jpg";